import React from "react";
import PropTypes from "prop-types";
import styles from "./SearchTips.module.css";

const defaultTips = [
  {
    title: "Search by name",
    pre: "Enter",
    chip: "Product:<name>",
    post: "or just the name.",
  },
  {
    title: "Search by SKU",
    pre: "Enter",
    chip: "SKU:<number>",
    post: "or just the SKU.",
  },
];

export function SearchTips({ heading = "Search Tips", tips = defaultTips }) {
  return (
    <div className={styles.card}>
      {heading && <p className={styles.heading}>{heading}</p>}
      <div className={styles.divider} />

      <div className={styles.tipList}>
        {tips.map(({ title, pre, chip, post }, idx) => (
          <div className={styles.tipItem} key={`${title}-${idx}`}>
            <p className={styles.tipTitle}>{title}</p>
            <p className={styles.tipText}>
              {pre && <span>{pre} </span>}
              {chip && <span className={styles.tipChip}>{chip}</span>}
              {post && <span> {post}</span>}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}

SearchTips.propTypes = {
  heading: PropTypes.string,
  tips: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      pre: PropTypes.string,
      chip: PropTypes.string,
      post: PropTypes.string,
    })
  ),
};
